import type { ComponentPropsWithoutRef, ReactElement } from 'react';
import { QontoLogo } from '@repo/design-system-kit';
import styles from './qonto-header.module.css';

type QontoHeaderProps = ComponentPropsWithoutRef<'div'>;

export function QontoHeader(props: QontoHeaderProps): ReactElement {
  return (
    <div {...props} data-test-qonto-header>
      <QontoLogo className={styles.logo} height={24} />
    </div>
  );
}
